import { createInstance as createInstance$1, setLogLevel, setLogger, enums } from '@optimizely/react-sdk';
import config from './common/config.js';
import { customLogger } from './common/logging/customLogger.js';
import { setAppName } from './common/utils.js';

var LogLevel = /*#__PURE__*/function (LogLevel) {
  LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
  LogLevel[LogLevel["INFO"] = 2] = "INFO";
  LogLevel[LogLevel["WARNING"] = 3] = "WARNING";
  LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
  return LogLevel;
}({});
var sdkInstance = null;
var createInstance = function createInstance(appName, options) {
  var initOption = options.initOption,
    sdkKey = options.sdkKey,
    dataFile = options.dataFile;
  setAppName(appName);
  if (sdkInstance) return sdkInstance;
  var dataFileOptions = {
    autoUpdate: options.autoUpdateConfigChanges !== undefined ? options.autoUpdateConfigChanges : config.shouldAutoUpdateDataFile,
    updateInterval: options.autoUpdateInterval !== undefined ? options.autoUpdateInterval : config.dataFileAutoUpdateInterval,
    urlTemplate: config.featureFlagProviderCDNEndpoint
  };
  switch (initOption) {
    case 'sdkKeyAndDataFile':
      {
        sdkInstance = createInstance$1({
          sdkKey: sdkKey,
          datafile: dataFile,
          datafileOptions: dataFileOptions
        });
        break;
      }
    case 'dataFile':
      {
        sdkInstance = createInstance$1({
          datafile: dataFile
        });
        break;
      }
    case 'sdkKey':
    default:
      {
        sdkInstance = createInstance$1({
          sdkKey: sdkKey,
          datafileOptions: dataFileOptions
        });
        break;
      }
  }
  setupLogger(options.logLevel !== undefined ? options.logLevel : LogLevel.ERROR);
  return sdkInstance;
};
var close = function close() {
  var _sdkInstance;
  (_sdkInstance = sdkInstance) === null || _sdkInstance === void 0 || _sdkInstance.close();
};
var getOptimizelyLogLevel = function getOptimizelyLogLevel(logLevel) {
  switch (logLevel) {
    case LogLevel.INFO:
      return enums.LOG_LEVEL.INFO;
    case LogLevel.DEBUG:
      return enums.LOG_LEVEL.DEBUG;
    case LogLevel.WARNING:
      return enums.LOG_LEVEL.WARNING;
    case LogLevel.ERROR:
    default:
      return enums.LOG_LEVEL.ERROR;
  }
};
var setupLogger = function setupLogger(logLevel) {
  setLogLevel(getOptimizelyLogLevel(logLevel));
  setLogger({
    log: customLogger
  });
};

export { LogLevel, close, createInstance };
